import { useEffect, useEffectEvent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TextField } from '../../../../components/generic.tsx'
import { I18n } from '../../../../components/I18n.tsx'
import { ids } from '../../../../ids.ts'
import type { BaseReportForm } from '../schema.ts'

export const NameField = <TForm extends BaseReportForm>({
	defaultName,
}: {
	// Pre-fills the name until the user edits it themselves
	defaultName: (values: TForm) => string
}) => {
	const { getValues } = useFormContext<TForm>()
	return <NameTextField defaultName={() => defaultName(getValues())} />
}

const NameTextField = ({ defaultName }: { defaultName: () => string }) => {
	const { setValue, control, getFieldState } = useFormContext<BaseReportForm>()

	const updateDefaultNameIfNotTouched = useEffectEvent(() => {
		if (!getFieldState('name').isTouched) {
			setValue('name', defaultName())
		}
	})

	// Re-applied every time the user enters the step, until they edit the name themselves
	useEffect(updateDefaultNameIfNotTouched, [])

	return (
		<Controller
			name='name'
			control={control}
			render={({ field, fieldState }) => (
				<TextField
					data-ta={ids.reports.form.reportDetails.name}
					label={<I18n i18nKey={($) => $.reports.form.name} />}
					required
					{...field}
					error={!!fieldState.error}
					helperText={fieldState.error?.message}
					size='small'
				/>
			)}
		/>
	)
}
